var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTakeaways(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#F7F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9518 23.662L23.648 20.3582C24.2635 19.537 24.6286 18.5178 24.6286 17.4148C24.6286 14.7033 22.4226 12.4974 19.7111 12.4974C16.9996 12.4974 14.7936 14.7033 14.7936 17.4148C14.7936 20.1263 16.9996 22.3323 19.7111 22.3323C20.814 22.3323 21.8333 21.9672 22.6545 21.3517L25.9583 24.6555C26.2326 24.9298 26.6774 24.9298 26.9518 24.6555C27.2261 24.3811 27.2261 23.9364 26.9518 23.662ZM16.1986 17.4148C16.1986 15.478 17.7743 13.9023 19.7111 13.9023C21.6479 13.9023 23.2236 15.478 23.2236 17.4148C23.2236 19.3516 21.6479 20.9273 19.7111 20.9273C17.7743 20.9273 16.1986 19.3516 16.1986 17.4148Z",
    fill: "#408C88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.21429 10.4286H24.6429C25.3135 10.4286 25.8571 9.88494 25.8571 9.21429C25.8571 8.54364 25.3135 8 24.6429 8H5.21429C4.54364 8 4 8.54364 4 9.21429C4 9.88494 4.54364 10.4286 5.21429 10.4286Z",
    fill: "#408C88"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0855 15.2857H5.21429C4.54364 15.2857 4 15.8294 4 16.5C4 17.1707 4.54364 17.7143 5.21429 17.7143H11.0855C11.7562 17.7143 12.2998 17.1707 12.2998 16.5C12.2998 15.8294 11.7562 15.2857 11.0855 15.2857Z",
    fill: "#408C88"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3154 22.5714H5.21429C4.54364 22.5714 4 23.1151 4 23.7857C4 24.4564 4.54364 25 5.21429 25H10.3154C10.9861 25 11.5297 24.4564 11.5297 23.7857C11.5297 23.1151 10.986 22.5714 10.3154 22.5714Z",
    fill: "#408C88"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakeaways);
export default __webpack_public_path__ + "static/media/Takeaways.840b6431646d4fb6dd8c2f32d8074f04.svg";
export { ForwardRef as ReactComponent };